/*
 * PBK Text Reveal — スクロール連動テキスト出現演出（assets/pbk-text-reveal.css と対）
 *
 * - .pbk-tr を IntersectionObserver で監視、交差で .is-visible 付与し unobserve（一度きり・逆再生しない）
 * - group（[data-pbk-tr-group]）単位で DOM 順に --tr-order を付与しスタガー。
 *   group 内のどれか 1 つが交差したら group 全体を同時に is-visible にし、delay で
 *   「英語見出し → 和文サブ → 本文」の段階表示にする（各 group 内で完結・セクションまたぎ無し）
 * - mask は transitionend（+ 取りこぼし用フォールバック timeout）で .pbk-tr--done を付与し
 *   clip を解除 → 最終ボックスを既存レイアウトとピクセル一致へ戻す
 * - reduced-motion / IntersectionObserver 非対応: observer を張らず全要素を即最終表示
 * - 初期化時に既に画面内の要素も IntersectionObserver の初回コールバックで処理される
 * - [data-pbk-tr-manual] 配下は IO 監視しない（外部 JS が window.pbkTextReveal.revealWithin(容器)
 *   で発火する手動ゲート。about-hero の「画像モーフが左カラムをクリアしてから出現」用）。
 *   reduced-motion / IO 非対応時は手動ゲートも即最終表示（ハーネス撮影の安全性を維持）
 */
(function () {
  'use strict';

  var SEL = '.pbk-tr';
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markDone(el) {
    if (el.classList.contains('pbk-tr--mask')) el.classList.add('pbk-tr--done');
  }

  function reveal(el) {
    if (el.classList.contains('is-visible')) return;
    el.classList.add('is-visible');

    if (!el.classList.contains('pbk-tr--mask')) return;

    var inner = el.querySelector('.pbk-tr__inner');
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      markDone(el);
    };
    if (inner) {
      inner.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') finish();
      });
    }
    // transitionend を取りこぼしても最終ボックスへ確実に戻すフォールバック
    var order = parseInt(el.style.getPropertyValue('--tr-order'), 10) || 0;
    setTimeout(finish, 1000 + order * 90);
  }

  function assignOrders() {
    var groups = document.querySelectorAll('[data-pbk-tr-group]');
    for (var i = 0; i < groups.length; i++) {
      var trs = groups[i].querySelectorAll(SEL);
      for (var j = 0; j < trs.length; j++) {
        trs[j].style.setProperty('--tr-order', j);
      }
    }
  }

  function revealGroup(el) {
    var group = el.closest('[data-pbk-tr-group]');
    var els = group ? group.querySelectorAll(SEL) : [el];
    for (var i = 0; i < els.length; i++) reveal(els[i]);
    return els;
  }

  function boot() {
    var all = document.querySelectorAll(SEL);
    if (!all.length) return;
    assignOrders();

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < all.length; i++) {
        reveal(all[i]);
        markDone(all[i]);
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var revealed = revealGroup(entry.target);
          for (var k = 0; k < revealed.length; k++) obs.unobserve(revealed[k]);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );

    for (var n = 0; n < all.length; n++) {
      // 手動ゲート配下（外部 JS が revealWithin で発火）は IO 監視しない
      if (all[n].closest('[data-pbk-tr-manual]')) continue;
      if (!all[n].classList.contains('is-visible')) observer.observe(all[n]);
    }
  }

  // 手動ゲート用: 容器内の .pbk-tr をまとめて reveal（stagger は --tr-order で維持）
  function revealWithin(container) {
    if (!container) return;
    var els = container.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) reveal(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  // hidden→表示（display:none 解除）等で IntersectionObserver が取りこぼした
  // .pbk-tr を再スキャンするための公開フック（例: pbk-customer-voice.js）。
  // boot は is-visible 済み要素を再 observe しないため冪等に呼べる。
  window.pbkTextReveal = { rescan: boot, revealWithin: revealWithin };
})();
